"use client";

import {
  BaseAutumnProvider
} from "./chunk-NJFRQ6T4.mjs";
import {
  AutumnContext
} from "./chunk-EOSHPHLH.mjs";
import {
  AutumnClient
} from "./chunk-XDAZD5HF.mjs";

// src/libraries/react/ReactAutumnProvider.tsx
import { jsx } from "react/jsx-runtime";
var ReactAutumnProvider = ({
  children,
  getBearerToken,
  backendUrl,
  customerData,
  includeCredentials = true
}) => {
  if (backendUrl && !backendUrl.startsWith("http")) {
    console.warn(`backendUrl is not a valid URL: ${backendUrl}`);
  }
  let client = new AutumnClient({
    backendUrl: backendUrl || "",
    getBearerToken,
    customerData,
    includeCredentials
  });
  return /* @__PURE__ */ jsx(BaseAutumnProvider, { client, AutumnContext, children });
};

export {
  ReactAutumnProvider
};
